import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;